module.exports = __webpack_public_path__ + "static/download_google-073320d03f73fe477f6f3c8cbe709bc4.png";